var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSliders = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M15 3.167a3.5 3.5 0 0 0-3.355 2.5H2.5a1 1 0 1 0 0 2h9.145a3.502 3.502 0 0 0 6.855-1 3.5 3.5 0 0 0-3.5-3.5M5 9.833a3.5 3.5 0 1 0 3.355 4.5H17.5a1 1 0 1 0 0-2H8.355A3.5 3.5 0 0 0 5 9.833"
})));
SvgSliders.displayName = "SvgSliders";
export { SvgSliders as ReactComponent };
export default SvgSliders;